export default __webpack_public_path__ + "70279126e5adbcff419734e08fba8acc.png";